class CollectionDescription extends HTMLElement {
  connectedCallback() {
    this.content = this.querySelector('.collection-description__content');
    this.toggle = this.querySelector('.collection-description__toggle');
    if (!this.content || !this.toggle) return;

    this.onResize = () => this.update();
    this.onClick = (event) => {
      if (!this.classList.contains('is-collapsible')) return;
      if (event.target.closest('.collection-description__toggle')) return;
      this.setExpanded(!this.classList.contains('is-expanded'));
    };
    this.onToggleClick = (event) => {
      event.preventDefault();
      event.stopPropagation();
      if (!this.classList.contains('is-collapsible')) return;
      this.setExpanded(!this.classList.contains('is-expanded'));
    };

    this.toggle.addEventListener('click', this.onToggleClick);
    this.addEventListener('click', this.onClick);
    window.addEventListener('resize', this.onResize);
    this.update();
  }

  disconnectedCallback() {
    this.toggle?.removeEventListener('click', this.onToggleClick);
    this.removeEventListener('click', this.onClick);
    window.removeEventListener('resize', this.onResize);
  }

  setExpanded(expanded) {
    this.classList.toggle('is-expanded', expanded);
    this.toggle.setAttribute('aria-expanded', expanded ? 'true' : 'false');
  }

  update() {
    const wasExpanded = this.classList.contains('is-expanded');
    this.classList.remove('is-expanded');
    this.classList.add('is-collapsible');

    const isOverflowing = this.content.scrollHeight > this.content.clientHeight + 1;

    if (!isOverflowing) {
      this.classList.remove('is-collapsible', 'is-expanded');
      this.toggle.hidden = true;
      this.toggle.setAttribute('aria-expanded', 'false');
      return;
    }

    this.toggle.hidden = false;
    if (wasExpanded) this.classList.add('is-expanded');
    this.toggle.setAttribute('aria-expanded', this.classList.contains('is-expanded') ? 'true' : 'false');
  }
}

if (!window.customElements.get('collection-description')) {
  window.customElements.define('collection-description', CollectionDescription);
}
